module.exports = __webpack_public_path__ + "static/img/2.cf86a87.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/sp/2.png
// module id = lZTa
// module chunks = 0